import { render } from "./MyPeoplePage.vue?vue&type=template&id=904c715e&scoped=true"
import script from "./MyPeoplePage.vue?vue&type=script&lang=js"
export * from "./MyPeoplePage.vue?vue&type=script&lang=js"

import "./MyPeoplePage.vue?vue&type=style&index=0&id=904c715e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-904c715e"]])

export default __exports__